<template>
  <v-dialog v-model="show" persistent max-width="400">
    <v-card :class="classContents">
      <v-card-title>
        <h3>{{ $t('system.jmx.add.title') }}</h3>
      </v-card-title>
      <v-form ref="form" v-model="valid">
        <v-row class="mx-3 mt-3">
          <v-col cols="12" class="pr-5">
            <v-card flat class="dialog-form" :class="classContents">
              <div class="d-flex flex-column">
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ $t('system.host') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-text-field v-model="item.host" :rules="[rules.required]" class="w-auto" outlined dense></v-text-field>
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ $t('system.port') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-text-field v-model="item.port" :rules="[rules.required]" type="number" min="1" max="65535" class="w-auto" outlined dense></v-text-field>
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ $t('system.username') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-text-field v-model="item.username" :rules="[rules.required]" class="w-auto" outlined dense></v-text-field>
                  </div>
                </div>
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ $t('system.password') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-text-field v-model="item.password" :rules="[rules.required]" class="w-auto" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword" outlined dense></v-text-field>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="register('jmx')" :disabled="disabledRegister">{{ $t('common.register') }}</v-btn>
        <v-btn small color="primary" @click="cancel">{{ $t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import addable from './mixins/addable';

const defaultItem = {
  host: '',
  port: '',
  username: '',
  password: '',
};

export default {
  mixins: [addable],
  data() {
    return {
      showPassword: false,
    };
  },
  computed: {
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  created() {
    this.item = defaultItem;
  },
};
</script>

<style scoped>
.empty {
  height: 50px;
}
</style>
